export const BulkJDImportStatus = {
    NOT_STARTED: 0,
    FILE_UPLOADED: 1,
    IN_PROGRESS: 2,
    COMPLETED: 3,
    COMPETED_WITH_ERRORS: 4,
    FAILED: 5
}